import React from 'react';
import { Navigate } from 'react-router-dom';
// lib
import { isLogin } from '../lib/auth';

const ConditionRouter = ({ type, children }) => {
    if (type === 'private' && isLogin() === false) return <Navigate to="/login" />
    else if (type === 'auth' && isLogin() === true) return <Navigate to="/" />
    return children;
}

export default ConditionRouter;